<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_26"></a><a id="page_27"></a><a id="part1"></a>PART 1.</h2>
<h2 class="h2a">REVISING THE CONCEPT OF BEAUTY</h2>
<p class="parttitle">LAYING THE GROUNDWORK</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?01df6df5